
    <ezs-admin-sign-in
      *ngIf="!(isAuthenticated$ | async)"
      [errorMsg]="authError$ | async" 
      (signIn)="signIn($event)">
    </ezs-admin-sign-in>
  